export default {
  id: 'faab7183d8',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page appList"  data-name="appList">\n        <div class="navbar" style="background-color: #EF5661!important;">\n            <div class="navbar-inner sliding" style="color: #ffffff!important;">\n                <div class="left">\n                    <a href="#" class="link back" style="color: #ffffff!important;">\n                        <i class="icon icon-back"></i>\n                        <span class="if-not-md">Back</span>\n                    </a>\n                </div>\n                <div id="" class="title" style="color: #ffffff!important;" >اَپـخـونـه : <span id="AppListName"></span></div>\n            </div>\n        </div>\n        <div class="page-content infinite-scroll-content" style="background-color: #F5F5F5 !important;">\n            <div class="list media-list divAppList">\n                <ul id="myAppList">\n                </ul>\n            </div>\n            <div class="preloader infinite-scroll-preloader"></div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};